import { CopyKey } from '../../../i18n';

export const CHOOSE_WISELY_COPY_KEY = 'steps.profile_setup.choose_wisely' satisfies CopyKey;

export const USERNAME_MAX_LENGTH = 15;
